export default "__VITE_ASSET__kzyNsxK1__"